export enum ActionButtonIcons {
	link = 'uncontained-theme',
	icon4 = 'icon-ghost-theme',
	visibilityIcon = 'visibility-on_b',
	// eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
	uncontained = 'uncontained-theme',
}
